import styled from 'styled-components';
import { Box } from '@mui/material';
import { getColor } from 'common/constants/_colors';

export const StyledWithValidation = styled(Box)`
  position: relative;
  &.hasError {
    & > *:first-child {
      border: 1px solid ${getColor('radicalRed')};
    }
  }
`;

export const StyledValidationError = styled.section`
  position: absolute;
  bottom: -1.6rem;
  color: ${getColor('radicalRed')};
  font-style: italic;
`;
